import Vue from 'vue';

import { Dialog, Button, Icon, Popup, Tabbar, TabbarItem, Swipe, SwipeItem, Field, Picker, Checkbox, Popover, Cell, RadioGroup, Radio, NoticeBar, Overlay } from 'vant';
import FastClick from 'fastclick';
import './assets/css/init.scss';
import VueCompositionAPI from '@vue/composition-api';
import eventReport, { EVENT_NAME } from './api/eventReport';

Vue.use(VueCompositionAPI);

Vue.use(Dialog);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Popup);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Field);
Vue.use(Picker);
Vue.use(Checkbox);
Vue.use(Popover);
Vue.use(Cell);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(NoticeBar);
Vue.use(Overlay);

Vue.config.productionTip = false;

const ERROR_MESSAGE_MAX_LENGTH = 500;

const sanitizeUrl = (url = location.href) => {
  try {
    const parsedUrl = new URL(url, location.origin);
    return `${parsedUrl.origin}${parsedUrl.pathname}`;
  } catch (e) {
    return location.origin + location.pathname;
  }
};

const formatElementError = target => {
  if (!target?.tagName) {
    return 'unknown error';
  }

  const tagName = String(target.tagName).toLowerCase();
  const resourceUrl = target.getAttribute?.('src') || target.getAttribute?.('href');

  return resourceUrl
    ? `<${tagName} ${target.getAttribute?.('src') ? 'src' : 'href'}="${sanitizeUrl(resourceUrl)}">`
    : `<${tagName}>`;
};

const sanitizeErrorMessage = message => {
  let text = '';

  if (typeof message === 'string') {
    text = message;
  } else {
    try {
      text = JSON.stringify(message || {});
    } catch (e) {
      text = String(message);
    }
  }

  return text.slice(0, ERROR_MESSAGE_MAX_LENGTH);
};

Vue.config.errorHandler = (err, vm, info) => {
  eventReport.track(EVENT_NAME.CRASH, {
    fail_type: 'vue_error',
    fail_message: sanitizeErrorMessage(`${info || ''}${err?.message ? `: ${err.message}` : ''}`.trim()),
    fail_url: sanitizeUrl()
  });
};

window.addEventListener('error', event => {
  const target = event?.target;
  const resourceUrl = target?.src || target?.href;
  const isResourceError = !!resourceUrl;
  eventReport.track(EVENT_NAME.CRASH, {
    fail_type: isResourceError ? 'resource_error' : 'js_error',
    fail_message: sanitizeErrorMessage(event?.message || formatElementError(target) || 'unknown error'),
    fail_url: sanitizeUrl(isResourceError ? resourceUrl : (event?.filename || location.href))
  });
}, true);

window.addEventListener('unhandledrejection', event => {
  const reason = event?.reason;
  eventReport.track(EVENT_NAME.CRASH, {
    fail_type: 'unhandledrejection',
    fail_message: sanitizeErrorMessage(typeof reason === 'string' ? reason : (reason?.message || JSON.stringify(reason || {}))),
    fail_url: sanitizeUrl()
  });
});

import '@vant/touch-emulator';

// 解决300ms延迟
FastClick.attach(document.body);

// 处理点击穿透问题
FastClick.prototype.focus = function(targetElement) {
  let length;
  if (
    targetElement.setSelectionRange &&
    targetElement.type.indexOf('date') !== 0 &&
    targetElement.type !== 'time' &&
    targetElement.type !== 'month'
  ) {
    length = targetElement.value.length;
    targetElement.focus();
    targetElement.setSelectionRange(length, length);
  } else {
    targetElement.focus();
  }
};

(async () => {
  await import('./mountApp');
})();
